/**
 * File: flatten_articles.ts
 * Description: Utility for flattening FAQ categories into a single list of articles,
 *                  each enriched with its parent category's id and title.
 */

import type { Category, ExtendedArticle } from "@/interfaces/category";

/**
 * Flattens a list of categories into a single list of articles, each enriched
 * with the id and title of the category it belongs to. Does not sort or filter;
 * callers apply their own ordering/filtering on top of the result.
 *
 * @param {Category[]} categories - Categories whose articles will be flattened.
 * @returns {ExtendedArticle[]} All articles across all categories, in their original order.
 */
export function flattenCategoryArticles(categories: Category[]): ExtendedArticle[] {
  return categories.flatMap(category =>
    category.articles.map(article => ({
      categoryId: category.id,
      categoryTitle: category.title,
      ...article,
    }))
  );
}
